/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Submit_SavingInputs */

const he_notifications_submit_saving = /** @type {(inputs: Notifications_Submit_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שומר...`)
};

const en_notifications_submit_saving = /** @type {(inputs: Notifications_Submit_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {Notifications_Submit_SavingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_submit_saving = /** @type {((inputs?: Notifications_Submit_SavingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Submit_SavingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_submit_saving(inputs)
	return en_notifications_submit_saving(inputs)
});